import { render, staticRenderFns } from "./ClusterSwitcher.vue?vue&type=template&id=3c3b51f2&"
import script from "./ClusterSwitcher.vue?vue&type=script&lang=js&"
export * from "./ClusterSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports